export const MIXPANEL_DEV_API_KEY = "08d354c7a4bc4a84a4593d5e4fb23944"